/** Liste découpée par 100. La page suivante charge le bloc suivant. */
import { useEffect, useState } from "react";
import "./listPager.css";

export const LIST_PAGE_SIZE = 100;

type PageView<T> = {
  slice: T[];
  page: number;
  pages: number;
  total: number;
  from: number;
  to: number;
  setPage: (page: number) => void;
};

export function usePagedRows<T extends { id: number }>(rows: T[]): PageView<T> {
  const [page, setPage] = useState(1);
  const sig = rows.map((row) => row.id).join(",");
  const pages = Math.max(1, Math.ceil(rows.length / LIST_PAGE_SIZE));
  const safe = Math.min(Math.max(1, page), pages);
  const start = (safe - 1) * LIST_PAGE_SIZE;

  useEffect(() => {
    setPage(1);
  }, [sig]);

  return {
    slice: rows.slice(start, start + LIST_PAGE_SIZE),
    page: safe,
    pages,
    total: rows.length,
    from: rows.length === 0 ? 0 : start + 1,
    to: Math.min(start + LIST_PAGE_SIZE, rows.length),
    setPage,
  };
}

export function ListPager({
  page,
  pages,
  total,
  from,
  to,
  setPage,
}: Omit<PageView<unknown>, "slice">) {
  if (total <= LIST_PAGE_SIZE) return null;
  return (
    <nav className="fx-pager" aria-label="Pages de la liste">
      <button type="button" disabled={page <= 1} onClick={() => setPage(page - 1)}>
        Précédent
      </button>
      <span>
        {from}–{to} sur {total}
      </span>
      <button type="button" disabled={page >= pages} onClick={() => setPage(page + 1)}>
        Suivant
      </button>
    </nav>
  );
}
